'use strict';

// NOTE!  Be sure to use // to comment lines below.  /* */ doesn't seem to work
// PROD2
export const APIURL: string = 'https://28qqus4afh.execute-api.us-west-2.amazonaws.com/prod2';
export const BERNIEAPIURL: string = 'https://3u2v40gcbl.execute-api.us-east-2.amazonaws.com/berniedev';
export const WEBSITEURL: string = 'http://webapp-prod2.s3-website-us-west-2.amazonaws.com/';
export const TENANTURL: string = 'https://mr2-tenantdata.s3.amazonaws.com';
export const GOVTENANTURL: string = 'https://s3-us-gov-west-1.amazonaws.com/mr2-tenantdata';
export const BUCKETNAME: string = 'mr2-tenantdata';

export const cognito_region = 'us-east-1';
export const cognito_identity_pool_id = 'us-east-1:ee071180-d87b-48e8-bf83-3d38dc6b5267';
export const cognito_user_pool_id = 'us-east-1_Wm4iZKPva';
export const cognito_client_id = '5rdfla1lchd1pe9fmh2ngfanha';

export const update_ProjectDataCache_timeDuration = 10;   // In minutes

export const ProjectType = {
  WORKSPACE: 1,
  PROJECT: 2
};

export const ProjectGetData = {
  TENANT: 1,
  CREATEDBY: 2,
  ASSIGNEDTO: 3,
  ACCOUNT: 4
};

export const EnabledType = {
  DISABLED: 0,
  ENABLED: 1,
  DELETED: 2
};



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/globals.ts